import React, { Component } from "react";
//// componentes reutilizables
import NumberFormat from "react-number-format";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import PagoDepositoExtraccionQrService from "../../../../services/operaciones-qr/PagoDepositoExtraccionQrService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleUp, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

import md5 from "md5";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import TransferQrService from "../../../../services/transferencias/TransferQrService";
import TecladoPin from "../../../generico/TecladoPin";
import { ModalPinTransaccional } from "../../../generico/ModalPinTransaccional";
export default class PagoDepositoExtraccionQrPaso3 extends Component {
  COD_PAGO_CUENTA_AHORRO = 'CCAHOO';
  COD_PARTICIPANTE = '1607';

  constructor(props) {
    console.log(JSON.stringify(props))
    super(props);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    pin: "",
    nroOperacion: 0,
    nombreSocio: undefined,
    cedulaSocio: undefined,
    nroSocio: undefined,
    formaPago: undefined,
    datoPago: undefined,
    tipoFondo: undefined,
    atmOComercio: "Comercio"
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };

  componentDidMount() {
    let usuario = AuthService.getCurrentUser();

    this.setState({
      nombreSocio: usuario.nombreCompleto,
      cedulaSocio: usuario.cedulaIdentidad,
      nroSocio: usuario.numeroSocio
    })
    if(this.props.modalidadPagoMotivo === "CCAHOO"){
      this.setState({formaPago: "CUENTA DE AHORRO", 
      datoPago: this.props.cuentaOrigen.ahorro + " - " + this.props.cuentaOrigen.descripcion,
      tipoFondo: "Cuenta"});
    } else if(this.props.modalidadPagoMotivo === "TCO"){
      this.setState({formaPago: "TARJETA " + this.obtenerTipoTarjeta(this.props.cuentaOrigen.value), 
      datoPago:this.props.cuentaOrigen.value.substring(0, 4) + "****" 
      + this.props.cuentaOrigen.value.substring(this.props.cuentaOrigen.value.length - 4, 
      this.props.cuentaOrigen.value.length),
      tipoFondo: "Tarjeta"});
    }
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerTipoTarjeta(nroTarjeta) {
    var prefijo = nroTarjeta.substring(0, 4);
    if (prefijo === "5150" || prefijo === "5418" || prefijo === "5358" || prefijo === "5402") {
      return "MASTER";
    }
    if (prefijo === "6020") {
      return "PANAL";
    }
    if (prefijo === "5896" || prefijo === "6042") {
      return "CABAL";
    }
  }


  confirmar = (e) => {

    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    let canalFinal = "CU24HS_WEB";

    // MODIFICACION CODIGO DE PARTICIPANTE SEGUN MODALIDAD DE PAGO
    let codParticipanteOrigen = "";

    if (this.props.modalidadPagoMotivo === "CCAHOO") {
      codParticipanteOrigen = "1607"
    } else {
      let tipoTarjeta = this.obtenerTipoTarjeta(this.props.cuentaOrigen.value);
      switch (tipoTarjeta) {
        case "PANAL":
          codParticipanteOrigen = "3601";
          break;
        case "CABAL":
          codParticipanteOrigen = "1600";
          break;
      }
    }

    if(this.props.datosQR.origenQr === 'BANCARDATM'){

      let data = {
  
        canalOrigen: canalFinal,
        origenQr: this.props.datosQR.origenQr,
        codOriginante: codParticipanteOrigen,
        tipoCuentaOrigen: this.props.modalidadPagoMotivo,
        numCuentaOrigen: this.props.modalidadPagoMotivo === "CCAHOO" ? this.props.cuentaOrigen.ahorro : this.props.cuentaOrigen.value, //// cuenta de ahorro o TC del socio
        docOriginante: this.state.cedulaSocio, ///// CI del socio
        idClienteEF: this.state.nroSocio, //nro de socio
        titularOriginante: this.state.nombreSocio, //// nombre del socio 
        cuotas: 1,
        adicional:this.props.datosQR.info
  
      }
  
      trackPromise(
        PagoDepositoExtraccionQrService.extraerAtmQr(data, 
          this.props.datosQR.titularDestinatario, this.props.datosQR.codDestinatario)
          .then((response) => {
            //// Habilita boton
            this.btn.removeAttribute("disabled");
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
  
            if(jData !== undefined && jData.header !== null){
              if (jData.header.codRespuesta === "0") {
                this.props.returnDataPaso3(null, this.props.datosTipoQR, this.props.datosQR.titularDestinatario,
                  this.props.importe, this.state.formaPago, this.state.datoPago, this.state.tipoFondo);
                this.nextStep.click();
              }else{
                Popup.queue(this.notifiPopup("Atención", jData.header.txtRespuesta));
              }
            } else {
              Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
            }
          })
      ).catch(function (error) {
        console.log(error)
        this.btn.removeAttribute("disabled");
        Popup.queue(Popup.register({
          title: "Error Inesperado.",
          content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
          buttons: {
            right: [
              {
                text: "Aceptar",
                className: "success",
                action: function () {
                  Popup.close();
                },
              },
            ],
          },
        }));
      });
  
    } else if(this.props.datosQR.codOperacion === 'COMP' || this.props.datosQR.origenQr === 'BANCARD'){

      let data = {

        codOriginante: codParticipanteOrigen,
        tipoCuentaOrigen: this.props.modalidadPagoMotivo,
        numCuentaOrigen: this.props.modalidadPagoMotivo === "CCAHOO" ? this.props.cuentaOrigen.ahorro : this.props.cuentaOrigen.value, //// cuenta de ahorro o TC del socio
        docOriginante: this.state.cedulaSocio, ///// CI del socio
        idClienteEF: this.state.nroSocio, //nro de socio
        titularOriginante: this.state.nombreSocio, //// nombre del socio
        importe: this.props.datosQR.importe,
        codComercio: this.props.datosQR.codComercio, ///// codComercio
        idQr: this.props.datosQR.idQr,
        titularDestinatario: this.props.datosQR.titularDestinatario, //// titularDestino
        docDestinatario: this.props.datosQR.docDestinatario, //// codComercio
        canalOrigen: canalFinal,
        origenQr: this.props.datosQR.origenQr,
        tipoQr: this.props.datosQR.tipoQr,
        idOperacionCaja: this.props.datosQR.idOperacionCaja,
        codParticipanteComercio: this.props.datosQR.codDestinatario,
        cuotas: this.props.datosQR.cuotas
  
      }

      trackPromise(
        PagoDepositoExtraccionQrService.pagarQr(data)
          .then((response) => {
            //// Habilita boton
            this.btn.removeAttribute("disabled");
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
  
            if(jData !== undefined && jData.data !== null){
              if (jData.data.codRespuesta === "0") {
                let numeroOperacion = jData.data.idOperacion;
                this.props.returnDataPaso3(numeroOperacion, this.props.datosTipoQR, this.props.datosQR.titularDestinatario,
                  this.props.importe, this.state.formaPago, this.state.datoPago, this.state.tipoFondo);
                this.nextStep.click();
              }else{
                Popup.queue(this.notifiPopup("Atención", jData.data.txtRespuesta));
              }
            } else {
              Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
            }
          })
      ).catch(function (error) {
        console.log(error)
        this.btn.removeAttribute("disabled");
        Popup.queue(Popup.register({
          title: "Error Inesperado.",
          content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
          buttons: {
            right: [
              {
                text: "Aceptar",
                className: "success",
                action: function () {
                  Popup.close();
                },
              },
            ],
          },
        }));
      });

    } else if(this.props.datosQR.codOperacion === 'DEPO'){


      let data = {

        canalOrigen: canalFinal,
        tipoQr: this.props.datosQR.tipoQr,
        codDestinatario: codParticipanteOrigen,
        tipoCuentaDestino: this.props.modalidadPagoMotivo === "CCAHOO" ? "CCAHOD" : this.props.modalidadPagoMotivo,
        numCuentaDestino: this.props.modalidadPagoMotivo === "CCAHOO" ? this.props.cuentaOrigen.ahorro : this.props.cuentaOrigen.value, //// cuenta de ahorro o TC del socio
        docDestinatario: this.state.cedulaSocio, ///// CI del socio
        idClienteEF: this.state.nroSocio, //nro de socio
        titularDestinatario: this.state.nombreSocio, //// nombre del socio
        importe: this.props.datosQR.importe,
        idQr: this.props.datosQR.idQr,        
        idOperacionCaja: this.props.datosQR.idOperacionCaja,
        codComercio: this.props.datosQR.codComercio, ///// codComercio
        codOriginante: this.props.datosQR.codOriginante,

      }

      trackPromise(
        PagoDepositoExtraccionQrService.depositarQr(data,
          this.props.datosQR.titularDestinatario)
          .then((response) => {
            //// Habilita boton
            this.btn.removeAttribute("disabled");
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
  
            if(jData !== undefined && jData.data !== null){
              if (jData.data.codRespuesta === "0") {
                let numeroOperacion = jData.data.idOperacion;
                this.props.returnDataPaso3(numeroOperacion, this.props.datosTipoQR, this.props.datosQR.titularDestinatario,
                  this.props.importe, this.state.formaPago, this.state.datoPago, this.state.tipoFondo);
                this.nextStep.click();
              }else{
                Popup.queue(this.notifiPopup("Atención", jData.data.txtRespuesta));
              }
            } else {
              Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
            }
          })
      ).catch(function (error) {
        console.log(error)
        Popup.queue(Popup.register({
          title: "Error Inesperado.",
          content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
          buttons: {
            right: [
              {
                text: "Aceptar",
                className: "success",
                action: function () {
                  Popup.close();
                },
              },
            ],
          },
        }));
      });

    } else if(this.props.datosQR.codOperacion === 'EXTR'){

      let data = {

        canalOrigen: canalFinal,
        tipoQr: this.props.datosQR.tipoQr,
        codOriginante: codParticipanteOrigen,
        tipoCuentaOrigen: this.props.modalidadPagoMotivo,
        numCuentaOrigen: this.props.modalidadPagoMotivo === "CCAHOO" ? this.props.cuentaOrigen.ahorro : this.props.cuentaOrigen.value, //// cuenta de ahorro o TC del socio
        docOriginante: this.state.cedulaSocio, ///// CI del socio
        idClienteEF: this.state.nroSocio, //nro de socio
        titularOriginante: this.state.nombreSocio, //// nombre del socio
        importe: this.props.datosQR.importe,
        idQr: this.props.datosQR.idQr,        
        idOperacionCaja: this.props.datosQR.idOperacionCaja,
        codDestinatario: this.props.datosQR.codDestinatario,
        codComercio: this.props.datosQR.codComercio, ///// codComercio
  
      }

      trackPromise(
        PagoDepositoExtraccionQrService.extraerQr(data, 
          this.props.datosQR.titularDestinatario)
          .then((response) => {
            //// Habilita boton
            this.btn.removeAttribute("disabled");
            var data = JSON.stringify(response.data);
            var jData = JSON.parse(data);
  
            if(jData !== undefined && jData.data !== null){
              if (jData.data.codRespuesta === "0") {
                let numeroOperacion = jData.data.idOperacion;
                this.props.returnDataPaso3(numeroOperacion, this.props.datosTipoQR, this.props.datosQR.titularDestinatario,
                  this.props.importe, this.state.formaPago, this.state.datoPago);
                this.nextStep.click();
              }else{
                Popup.queue(this.notifiPopup("Atención", jData.data.txtRespuesta));
              }
            } else {
              Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado. Intente de nuevo más tarde."));
            }
          })
      ).catch(function (error) {
        console.log(error)
        Popup.queue(Popup.register({
          title: "Error Inesperado.",
          content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
          buttons: {
            right: [
              {
                text: "Aceptar",
                className: "success",
                action: function () {
                  Popup.close();
                },
              },
            ],
          },
        }));
      });

    }

    //this._ui.dismissLoader();
  }

  pinValue = (value) => {
    this.setState({
      pin: value,
    });
    this.enableNextPin(value);
  };

  enableNextPin(pin) {
    if (pin !== "" && pin.length === 6) {
      this.state.disableSgte = false;
    } else {
      this.state.disableSgte = true;
    }
  }

  confirmarTransferencia = (e) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.importe.split('.').join('');
    importe = String(importe).replace(/\,/g, ".");

    
    let data = JSON.stringify({
      canalOrigen         : "CU24HS_WEB",
      ciOriginante        : this.state.cedulaSocio,
      idClienteEF         : this.state.nroSocio,
      codOriginante       : this.COD_PARTICIPANTE,
      titularOriginante   : this.state.nombreSocio,
      numCuentaOrigen     : this.props.cuentaOrigen.ahorro,
      tipoCuentaOrigen    : this.COD_PAGO_CUENTA_AHORRO,
      codDestinatario     : this.props.datosQR.codDestinatario,
      docDestinatario     : this.props.datosQR.docDestinatario,
      titularDestinatario : this.props.datosQR.titularDestinatario,
      numCuentaDestino    : this.props.datosQR.numCuentaDestino,
      tipoCuentaDestino   : this.props.datosQR.tipoCuentaDestino,
      importe             : importe,
      idQr                : this.props.datosQR.idQr,
      motivoOperacion     : this.props.modalidadPagoMotivo,
      pinTransaccional    : md5(this.state.pin)
    });

    trackPromise(
      TransferQrService.confirmarTransferencia(data)
        .then((response) => {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);

          if(jData !== undefined && jData !== null){
            if (jData.codigoRetorno === "0") {
              let numeroOperacion = jData.datos.idTxOriginante;
              this.props.returnDataPaso3(numeroOperacion, null, null,
                this.props.importe, null, null, null);
              this.nextStep.click();
            }else{
              Popup.queue(this.notifiPopup("Error", jData.mensajeRetorno));
            }
          } else {
            Popup.queue(this.notifiPopup("Error", "Tiempo de espera agotado. Verifique si se realizó el débito de su cuenta o intente más tarde."));
          }
        })
    ).catch(function (error) {
      console.log(error)
      Popup.queue(Popup.register({
        title: "Error Inesperado.",
        content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
        buttons: {
          right: [
            {
              text: "Aceptar",
              className: "success",
              action: function () {
                Popup.close();
              },
            },
          ],
        },
      }));
    });
  };

  BotonConfirmar = () => {
    if( (this.props.datosQR.origenQr === 'BANCARDATM') || 
    (this.props.datosQR.codOperacion === 'COMP' || this.props.datosQR.origenQr === 'BANCARD') ||
    (this.props.datosQR.codOperacion === 'EXTR') ){
      return(
        <>
          <button
            data-toggle="modal"
            data-target="#modal-pin-qr"
            ref={btn => { this.btn = btn; }}
            className="btn btn-cu-primary"
            disabled={this.state.disableSgte}
          >
            Confirmar {this.props.datosTipoQR.tipoQR} <FontAwesomeIcon icon={faArrowRight} />

          </button>
          <ModalPinTransaccional id="modal-pin-qr" onSuccess={() => this.confirmar()} />
        </>
      );
    } else {
      return(
        <button ref={btn => { this.btn = btn; }}
          className="btn btn-cu-primary"
          disabled={this.state.disableSgte}
          onClick={this.confirmar}
        >
          Confirmar {this.props.datosTipoQR.tipoQR} <FontAwesomeIcon icon={faArrowRight} />

        </button>
      );
    }
  }

  render() {
    if(this.props.datosQR.codOperacion == 'TRANF'){
      return (
        <div>
          <form id="idFormPaso3" onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="steps clearfix">
                <ul role="tablist">
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">
                        <span className="title_text current">
                          Leer código QR
                        </span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">
                        <span className="title_text">Datos del QR</span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="current">
                    <span>
                      <div className="title">
                        <span className="title_text">Datos de Verificación</span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled last">
                    <span>
                      <div className="title">
                        <span className="title_text">Confirmación</span>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
  
            <div className="row">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-8" style={{ marginBottom: 5 }}>
                    <h6 style={{ margin: 0 }}>
                      Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                      {AuthService.getSocio().nombreCompleto.trim()}
                    </h6>
                    <p style={{ marginBottom: 0 }}>
                      Tipo: {this.props.cuentaOrigen.descripcion}
                    </p>
                    <p>Moneda: {this.props.cuentaOrigen.moneda}</p>
                  </div>
                </div>
                <div className="row invoice-info">
                  <div className="col-12">
                    <div className="table-responsive">
                      {this.props.cuen}
                      <table className="table">
                        <tbody>
                          <tr>
                            <th>Cuenta Crédito:</th>
                            <td>{this.props.datosQR.numCuentaDestino}</td>
                          </tr>
                          <tr>
                            <th>Importe del Crédito:</th>
                            <td>
                              <NumberFormat
                                value={this.props.importe}
                                displayType={"text"}
                                decimalSeparator={","}
                                thousandSeparator={"."}
                              />{" "}
                              {this.props.cuentaOrigen.moneda}.
                            </td>
                          </tr>
                          <tr>
                            <th>Titular de la cuenta destino:</th>
                            <td>{this.props.datosQR.titularDestinatario}</td>
                          </tr>
                          {/* <tr>
                            <th>Tipo documento de la cuenta destino:</th>
                            <td>{this.props.datosQR.tipoDocDestino}</td>
                          </tr> */}
                          <tr>
                            <th>Documento de la cuenta destino:</th>
                            <td>{this.props.datosQR.docDestinatario}</td>
                          </tr>
                          <tr>
                            <th>Motivo:</th>
                            <td>{this.props.modalidadPagoMotivo}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row invoice-info">
                  <div className="col-12">
                    <MensajeUsuario tipo="INFO"
                      titulo="Importante!"
                      mensaje="El límite diario es de 6.000.000 Gs. (establecido por Bancard)." />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                  <div className="invoice p-3 mb-3 teclados">
                    <TecladoPin
                      pinValue={this.pinValue.bind(this)}
                      label="Ingrese el Pin de Transacción"
                    />
                  </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-6 col-md-6"></div>
              <div className="col-lg-3 col-md-3 btn-consulta">
              <button
                className="btn btn-cu-quintary"
              
                onClick={this.props.previousStep}
              >
              <FontAwesomeIcon icon={faArrowLeft}/>  Volver
              </button>
              </div>
              <div className="col-lg-3 col-md-3">
              <button ref={btn => { this.btn = btn; }}
                className="btn btn-cu-primary"
                disabled={this.state.disableSgte}
                onClick={this.confirmarTransferencia}
              >
              <FontAwesomeIcon icon={faArrowAltCircleUp} />  Confirmar Transferencia
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
              </div>
              
              
            </div>
          </form>
        </div>
      );
    }
    return (
      <div>
        <form id="idFormPaso3" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Leer código QR
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos del QR</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

      
          <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
          <div className="invoice p-3 mb-3">
            <h6>
                Tipo: {this.props.datosTipoQR.titulo} 
            </h6>
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <th>{this.props.datosTipoQR.atmOComercio}:</th>
                    <td>{this.props.datosQR.titularDestinatario}</td>
                  </tr>
                  <tr>
                    <th>Titular de la {this.state.tipoFondo}:</th>
                    <td>{AuthService.getSocio().nombreCompleto.trim()}</td>
                  </tr>
                  <tr>
                    <th>{this.props.datosTipoQR.formaPago}</th>
                    <td>{this.state.formaPago}</td>
                  </tr>                        
                  <tr>
                    <th>Datos de {this.props.datosTipoQR.tipoQR}:</th>
                    <td>{this.state.datoPago}</td>
                  </tr>
                  {this.props.datosQR.origenQr !== 'BANCARDATM' && (
                  <tr>
                    <th>Total a {this.props.datosTipoQR.accionQR}:</th>
                    <td>
                      <NumberFormat
                        value={this.props.importe}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                      />{" "} GS.
                    </td>
                  </tr>
                  )}
                </tbody>
              </table>
            </div>
            </div>
            </div>
          </div>
          <hr />
          <div className="row ">
            <div className="col-lg-8 col-md-4"></div>
            <div className="col-lg-2 col-md-4">
            <button
              className="btn btn-cu-quintary btn-consulta"
              onClick={this.props.previousStep}
            >
             <FontAwesomeIcon icon={faArrowLeft} />  Volver
            </button>
            </div>
            <div className="col-lg-2 col-md-4">
              {<this.BotonConfirmar />}
            </div>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
          </div>
        </form>
      </div>
    );
  }
}
